import React, { useState } from 'react';
import { X, Zap } from 'lucide-react';
interface AlertBarProps {
  userState?: string;
}
export function AlertBar({
  userState = 'tu área'
}: AlertBarProps) {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  const message = `⚡ Residentes de ${userState}: Tarifas en su punto más bajo. ¡Compara ahora!   ·   ⚡ Residentes de ${userState}: Tarifas en su punto más bajo. ¡Compara ahora!   ·   `;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-alert-bg border-b border-alert-border px-2 py-1.5 flex items-center shadow-sm overflow-hidden" data-id="element-56">
      <div className="flex-1 overflow-hidden relative" data-id="element-57">
        <div className="flex animate-marquee whitespace-nowrap" data-id="element-58">
          <span className="text-alert-text text-[10px] sm:text-xs font-medium" data-id="element-59">
            {message}
          </span>
          <span className="text-alert-text text-[10px] sm:text-xs font-medium" data-id="element-60">
            {message}
          </span>
        </div>
      </div>
      <button onClick={() => setIsVisible(false)} className="ml-2 text-alert-text hover:text-opacity-70 transition-colors p-0.5 flex-shrink-0" aria-label="Cerrar alerta" data-id="element-61">
        <X className="w-3 h-3" data-id="element-62" />
      </button>
    </div>;
}